// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"621":"supporter","774":"imprint","983":"products"}[chunkId] + "." + {"621":"0f83bc22","774":"4259a5ec","983":"89570f0d"}[chunkId] + ".css";
};